import { OrderLoading, UpdateOrderLoadingPaylod } from "../../../../api/types/order"
import { regex } from "../../../../common/regex"
import { FormErrors } from "../../../FieldError"

export const validateLoading = (data: UpdateOrderLoadingPaylod): [boolean, FormErrors<OrderLoading>] => {
  let isValid: boolean = true;
  let errors: FormErrors<OrderLoading> = {}

  if (!data.loading.name) {
    errors.name = "Název odesílatele je povinné pole."
    isValid = false
  }

  if (!data.loading.street) {
    errors.street = "Ulice a číslo domu je povinné pole."
    isValid = false
  }

  if (!data.loading.zip) {
    errors.zip = "PSČ je povinné pole."
    isValid = false
  }

  if (!data.loading.city) {
    errors.city = "Obec je povinné pole."
    isValid = false
  }

  if (!data.loading.country) {
    errors.country = "Stát je povinné pole."
    isValid = false
  }

  if (data.loading.notifyPhone && !data.loading.phone && !data.loading.mobile) {
    errors.phone = "Telefon je povinné pole."
    isValid = false
  }

  if (data.loading.notifyPhone && !data.loading.mobile && !data.loading.phone) {
    errors.mobile = "Mobil je povinné pole."
    isValid = false
  }

  if (data.loading.email && !regex.email.test(data.loading.email)) {
    errors.email = "E-mail není ve správném formátu."
    isValid = false
  }

  return [isValid, errors]
}
